import {
  Server,
  Github,
  GitBranch,
  Bot,
  Monitor,
  Rocket,
  Plug,
  Cog,
  KeyRound,
  Container,
} from 'lucide-react';

const ICON_MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  Server,
  Github,
  GitBranch,
  Bot,
  Monitor,
  Rocket,
  Plug,
  Cog,
  KeyRound,
  Container,
};

const DEFAULT_ICON = Cog;

export function resolveIcon(name?: string): React.ComponentType<{ className?: string }> {
  if (!name) return DEFAULT_ICON;
  return ICON_MAP[name] ?? DEFAULT_ICON;
}
